{
  "aboutProject": "About project",
  "accountSettings": "Account settings",
  "activities": "Activities",
  "activity": "Activity",
  "application": "Application",
  "areasOfInterest": "Areas of interest",
  "chooseCluster": "Choose network",
  "cluster": "Cluster",
  "clusterManagement": "Cluster management",
  "clusterOperation": "Cluster operation",
  "clusterVisionMission": "Cluster vision and mission",
  "companyInformation": "Company information",
  "contactInformation": "Contact information",
  "contacts": "Contacts",
  "coreData": "Core data",
  "economy": "Economy",
  "events": "Events",
  "financing": "Financing",
  "focusAreas": "Focus areas",
  "goalAccomplishment": "Goal accomplishment",
  "graphical": "Make your own entry link to One Way In",
  "home": "Home",
  "hourlyRate": "Hourly rate",
  "ideasAndCompanies": "Ideas and companies",
  "ideasAndCompaniesHeader": "Manage ideas, companies and alumni",
  "inFinancedProjects": "Projects financed by Innovation Norway",
  "mainGoal": "Main goal",
  "memberCompanySelfEffortOverview": "Member company's self-effort overview",
  "memberInformation": "Member information",
  "customers": "Customers",
  "membershipFee": "Membership fee",
  "membershipFeesAndSelfEffort": "Membership fees and self-effort",
  "opportunities": "Opportunities",
  "opportunitiesHeader": "Manage customer opportunities",
  "overview": "Overview",
  "ownProjects": "Own projects",
  "participants": "Participants",
  "portal": "Multi-Company Portal",
  "projectCategories": "Project categories",
  "projectDetail": "Project details",
  "Projects": "Projects",
  "projects": "Project categories",
  "reports": "Reports",
  "resourceBase": "Customer registry",
  "selfEffort": "In kind",
  "selfEffortContactOverview": "Contact´s self-effort overview",
  "selfEffortOverview": "Self-effort overview",
  "statistics": "Statistics",
  "subProjects": "Projects",
  "visionMission": "Vision and mission",
  "yourProfile": "Your profile",
  "assignments": "Assignments",
  "allMeetings": "All meetings",
  "allEvents": "All events",
  "sivaContacts": "Contacts",
  "sivaReporting": "Reporting",
  "sivaReporting.Header": "Reporting and follow up",
  "sivaDataExtract": "Data extract",
  "myContactInformation": "My contact info",
  "editMyContactInformation": "Edit my contact information",
  "actorProfile": "Actor profile",
  "settings": "Settings",
  "accessControls": "Access Control",
  "editAccessControls": "Edit access",
  "mailSettings": "E-mail Alerts",
  "editMailSettings": "Edit email alerts",
  "targetedCompanies": "Targeted companies",
  "frontPage": "Home",
  "services": "Service catalog",
  "services.Header": "View and register services",
  "invoices": "Invoices"
}
